import React, { Component } from 'react';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import { Mutation } from 'components/common/Query';
import SendPushNotification from './SendPushNotification';

export const SEND_PUSH_NOTIFICATION_MUTATION = gql`
  mutation sendPushNotification(
    $email: String!
    $notificationTypeName: String!
    $payload: String!
  ) {
    sendPushNotification(
      input: {
        email: $email
        notificationTypeName: $notificationTypeName
        payload: $payload
      }
    ) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

class SendPushNotificationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      errors: [],
    };
    this.Compose = adopt({
      mutateSendPushNotification: this.SendPushNotificationMutation,
    });
  }

  SendPushNotificationCompleted = ({ sendPushNotification: { errors } }) => {
    if (errors) {
      this.setState({ errors, success: false });
    } else {
      this.setState({ errors: [], success: true });
    }
  };

  SendPushNotificationMutation = ({ render }) => (
    <Mutation
      mutation={SEND_PUSH_NOTIFICATION_MUTATION}
      onCompleted={this.SendPushNotificationCompleted}
    >
      {handleSendPushNotificationMutation =>
        render({ handleSendPushNotificationMutation })
      }
    </Mutation>
  );

  /**
   * @description
   * Render SendPushNotification component.
   *
   * @returns {*} SendPushNotification component.
   */
  render() {
    const { errors, success } = this.state;
    return (
      <this.Compose>
        {({
          mutateSendPushNotification: { handleSendPushNotificationMutation },
        }) => (
          <SendPushNotification
            errors={errors}
            success={success}
            closeNotification={() =>
              this.setState({ errors: [], success: false })
            }
            sendPushNotification={variables =>
              handleSendPushNotificationMutation({ variables })
            }
          />
        )}
      </this.Compose>
    );
  }
}

export default SendPushNotificationContainer;
